export const getRobotsContent = (indexable: boolean | undefined, page: number): string | null => {
  if (indexable === false) {
    return 'noindex';
  }

  if (indexable && page > 1) {
    return 'noindex, follow';
  }

  return null;
};
